import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManageContainerListPage } from './manage-container-list.page';

const routes: Routes = [
  {
    path: '',
    component: ManageContainerListPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageContainerListPageRoutingModule {}
